export const PASSWORD_REQUIREMENTS = {
  MIN_LENGTH: 8,
  REQUIRE_UPPERCASE: true,
  REQUIRE_NUMBER: true,
  REQUIRE_SPECIAL: true
};

export const PASSWORD_REQUIREMENT_LABELS = [
  {
    key: 'hasUppercase',
    label: '1 uppercase letter',
    description: 'At least one uppercase letter (A-Z)'
  },
  {
    key: 'hasNumber', 
    label: '1 number',
    description: 'At least one number'
  },
  {
    key: 'hasSpecial',
    label: '1 special character',
    description: 'At least one special character (!@#$%^&*, etc.)'
  },
  {
    key: 'hasMinLength',
    label: '8 characters',
    description: 'Minimum 8 characters long'
  }
];